import { MODALS, COOKIES } from 'common/domain/constants';

class ModalCoachmarkController {

  constructor( cookieService, $scope, visitedStatesService, EventEmitter) {
    'ngInject';
    this.cookieService = cookieService;
    this.scope = $scope;
    this.EventEmitter = EventEmitter;
    this.currentSlide = 0;
    this.visitedStatesService = visitedStatesService;
  }

  $onInit() {
    if (this.isInception || this.visitedStatesService.stateVisited(this.data.state)) {
      return;
    }

    if (!this.userHasSeenCoachmark()) {
      this.visitedStatesService.setVisited(this.data.state);
      this.initModal();
      this.initCarousel();
    }
  }

  get FIRST_SLIDE() {
    return 0;
  }

  get LAST_SLIDE() {
    return this.data.imgs.length -1;
  }

  get carousel() {
    return $('#modalCoachmarkCarousel');
  }

  initModal() {
    this.modal = $(MODALS.COACHMARK);
    this.modal.on('hidden.bs.modal', () => this.onDismiss());
    this.modal.modal();
  }

  initCarousel() {
    this.carousel.on('slide.bs.carousel', ({direction}) => {
      this.currentSlide = (direction === 'left') ? this.currentSlide + 1 : this.currentSlide - 1;
      this.checkOutOfBounds();
      this.scope.$apply();
    });
  }

  checkOutOfBounds() {
    if (this.currentSlide < this.FIRST_SLIDE) this.currentSlide = this.LAST_SLIDE;
    if (this.currentSlide > this.LAST_SLIDE) this.currentSlide = this.FIRST_SLIDE;
  }

  userHasSeenCoachmark() {
    return this.cookieService && this.cookieService.get(this.getCookieName());
  }

  onDismiss() {
    this.cookieService.put(this.getCookieName(), this.dontShowAgain);

    this.coachmarkDismissed(this.EventEmitter({
      modalDismissed: true
    }));

    this.modal.modal('hide');
  }

  getNumberArray(num) {
    return new Array(num);
  }

  getCookieName() {
    return `${this.data.module}${this.data.tab}${COOKIES.COACHMARK}${this.userId}`;
  }

}

export default ModalCoachmarkController;



// WEBPACK FOOTER //
// ./client/app/components/modalCoachmark/modalCoachmark.controller.js